export default {
  translation: {
    common: {
      emailOrUsername: '邮箱或用户名',
      invalidUsernameOrPassword: '用户名或密码错误',
      logInToBoards: '登录',
      noInternetConnection: '没有网络连接',
      pageNotFound_title: '页面找不到',
      password: '密码',
      serverConnectionFailed: '服务连接失败',
      unknownError: '未知错误，请稍后重试',
    },

    action: {
      logIn: '登录',
    },
  },
};
